import { useParams, useSearchParams } from "react-router-dom";
import React, { useContext } from "react";
import { Container } from "react-bootstrap";
import { Card } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import MenuContext from "../store/menu-context";


const RedirectToExternal = (props) => {

    const params = useParams();
    const [searchParams] = useSearchParams();
    const navObject = useContext(MenuContext);


    let source = searchParams.get("source");
    console.log("source: ", source);
    let target = searchParams.get("target");
    console.log("target: ", target);

    const makeRedirect = () => {
        const externalDestination = params.externalDestination;
      
        if(target === "self"){
            window.open(navObject["redirect"][externalDestination], '_self');
        }else {
            window.open(navObject["redirect"][externalDestination], '_blank');
        }

        window.open(source, '_self');

        return(
            <Container className="container py-5 h-100">
                <Card className="text-center">
                    <Card.Body>
                    <Card.Title>Redirecting</Card.Title>
                    <Card.Text>
                        You are being redirected to <a href={navObject["redirect"][externalDestination]} target="_blank">{navObject["redirect"][externalDestination]}</a> in <strong>3 seconds</strong> seconds. Sometimes the popup blocker can prevent that. If you are not redirected automatically, please click the button below to open the link in a separate window.
                    </Card.Text>
                    <Button 
                        variant="success"
                        className="shadow-lg"
                        size="sm"
                        href={navObject["redirect"][externalDestination]}
                        target="_self"
                        // onLoad={openInNewTab}
                    >Open Link</Button>
                    </Card.Body>
                </Card>
            </Container>
       )

    }

    return(
        <>
            {makeRedirect()}
        </>
    )
}

export default RedirectToExternal;